module.exports = __webpack_public_path__ + "img/bot_kqjqr.d9d29115.png";